import type { CSSObject, Theme } from '@mui/material/styles';
import { TEMPERATURE_THRESHOLDS } from './types';

const ANIMATION_DURATIONS = {
  PULSE: 2000,
  PULSE_FAST: 1500,
  UPDATE: 600,
} as const;

export const ANIMATIONS = {
  PULSE: `pulse ${ANIMATION_DURATIONS.PULSE}ms infinite`,
  PULSE_RECONNECT: `pulse ${ANIMATION_DURATIONS.PULSE_FAST}ms ease-in-out infinite`,
  VALUE_UPDATE: `valueUpdate ${ANIMATION_DURATIONS.UPDATE}ms ease-out`,
  LIVE_INDICATOR: `liveIndicator ${ANIMATION_DURATIONS.PULSE_FAST}ms ease-in-out infinite`,
} as const;

export const keyframes: Record<string, CSSObject> = {
  '@keyframes pulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.4 },
    '100%': { opacity: 1 },
  },
  '@keyframes valueUpdate': {
    '0%': {
      opacity: 1,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 0.7,
      transform: 'scale(1.02)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
  '@keyframes liveIndicator': {
    '0%': { opacity: 1 },
    '70%': { opacity: 0.3 },
    '100%': { opacity: 1 },
  },
} as const;

export function getTemperatureColor(temperature: number, theme: Theme): string {
  if (temperature >= TEMPERATURE_THRESHOLDS.CRITICAL) {
    return theme.palette.error.main;
  }
  if (temperature >= TEMPERATURE_THRESHOLDS.WARNING) {
    return theme.palette.error.main;
  }
  if (temperature >= TEMPERATURE_THRESHOLDS.INCIDENT) {
    return theme.palette.warning.main;
  }
  return theme.palette.text.primary;
}

export const COLUMN_FLEX = {
  DEVICE_NAME: { flex: 1, minWidth: 140 },
  UNIT_ID: { flex: 0.6, minWidth: 80 },
  RACK_ID: { flex: 0.8, minWidth: 100 },
  TEMPERATURE: { flex: 1.2, minWidth: 180 },
  TIMESTAMP: { flex: 1, minWidth: 160 },
  HISTORICAL_CHART: { flex: 0.8, minWidth: 120 },
} as const;

export const SPACING = {
  COMPACT: 0.5,
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3,
} as const;

export const headerStyles = {
  fontWeight: 'normal',
} as const;
